/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesAccountsAccountAddressPngRequest = {
  accountAddress: string;
};

/** @internal */
export const GetApiV3ImagesAccountsAccountAddressPngRequest$inboundSchema:
  z.ZodType<
    GetApiV3ImagesAccountsAccountAddressPngRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    account_address: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "account_address": "accountAddress",
    });
  });

/** @internal */
export type GetApiV3ImagesAccountsAccountAddressPngRequest$Outbound = {
  account_address: string;
};

/** @internal */
export const GetApiV3ImagesAccountsAccountAddressPngRequest$outboundSchema:
  z.ZodType<
    GetApiV3ImagesAccountsAccountAddressPngRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ImagesAccountsAccountAddressPngRequest
  > = z.object({
    accountAddress: z.string(),
  }).transform((v) => {
    return remap$(v, {
      accountAddress: "account_address",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesAccountsAccountAddressPngRequest$ {
  /** @deprecated use `GetApiV3ImagesAccountsAccountAddressPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesAccountsAccountAddressPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesAccountsAccountAddressPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesAccountsAccountAddressPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesAccountsAccountAddressPngRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3ImagesAccountsAccountAddressPngRequest$Outbound;
}

export function getApiV3ImagesAccountsAccountAddressPngRequestToJSON(
  getApiV3ImagesAccountsAccountAddressPngRequest:
    GetApiV3ImagesAccountsAccountAddressPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesAccountsAccountAddressPngRequest$outboundSchema.parse(
      getApiV3ImagesAccountsAccountAddressPngRequest,
    ),
  );
}

export function getApiV3ImagesAccountsAccountAddressPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesAccountsAccountAddressPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesAccountsAccountAddressPngRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ImagesAccountsAccountAddressPngRequest' from JSON`,
  );
}
